import axios from "axios";
let burl = process.env.VUE_APP_API;
import {shieldHeaders} from "../http_common";

export function getAllOpcoGroupByOpco(){
    return axios.get(burl + '/api/opco/opco',{
        headers : shieldHeaders
    });
}
